import { useState, useEffect, useCallback } from 'react';
import { Alert, Button, Form, Col, Row, Container } from 'react-bootstrap';
import { fetchAuthorized } from '../utils/fetchAuthorized';
import { useMsal } from '@azure/msal-react';
import { Unauthorized } from '../components/login/Unauthorized';
import Select from 'react-select';


export function ExpensePage() {

  const { instance } = useMsal();
  const [alertShow, setAlertShow] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("primary");
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(null);
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    const getUsers = async () => {
      try {
        if(users && users.length > 0)
          return;
        const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}expenses/users`);
        if(!response.ok) {
          if(response.status === 403)
            setUnauthorized(true);
          else
            throw new Error('Could not retrieve users.');
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        showAlert("danger", "Could not retreive users.");
      } finally {
        setLoading(false);
      }
    };

  const getProjects = async () => {
    try {
      if(projects && projects.length > 0)
        return;
      const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}expenses/projects`);
      if(!response.ok) {
        if(response.status === 403)
            setUnauthorized(true);
        else
          throw new Error('Could not retrieve projects.');
      }
      const data = await response.json();
      setProjects(data);
    } catch (error) {
      showAlert("danger", "Could not retreive projects.");
    } finally {
      setLoading(false);
    }
  };

  getUsers();
  getProjects();
  }, [instance]);

  const showAlert = (variant, message) => {
      setAlertVariant(variant);
      setAlertMessage(message);
      setAlertShow(true);
  }

  const generateReport = async (event) => {
    event.preventDefault();
    setLoading(true);
    
    try {
      const data = JSON.stringify({
          userId: user.id,
          projectId: project.ramp_id,
          fromDate: fromDate,
          toDate: toDate
      });
      var params = {
          method: "POST",
          body: data,
          headers: {
              "Content-type": "application/json; charset=UTF-8",
          }
      };

      const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}expenses/report`, params);
      
      if (response.ok) {
        const fileName = `${user.first_name}-${user.last_name}-${project.value}.pdf`;
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        showAlert("success", `Successfully created ${fileName}`);
      }
      else {
        if(response.status === 404)
          showAlert("danger", "No Expenses found.");
        else
          showAlert("danger", "Could not create expense report.");
      }
    } catch (error) {
        showAlert("danger", error.message);
    } finally {
        setLoading(false);
    }
  }

  if(loading)
        return (
          <div className="h-100 d-flex justify-content-center align-items-center">
            <span className="spinner-border text-primary" style={{width: "4rem", height: "4rem"}} role="status" />
          </div>
        )
  if(unauthorized)
    return ( <Unauthorized /> );

    return (
        <div className="flex-box container-fluid align-items-center">
          <Container className="p-0" style={{ maxWidth: '800px' }}>
            <Alert variant={alertVariant} show={alertShow} onClose={() => setAlertShow(false)} dismissible>
                {alertMessage}
            </Alert>
          </Container>
          <Container className="p-5 bg-light border rounded shadow-sm align-items-center justify-content-center mt-3" style={{ maxWidth: '800px' }}>
            <h2>
              Expense Report
            </h2>

            <Form onSubmit={generateReport}>
                <Form.Group as={Row} className="mt-5" controlId="user">
                    <Form.Label column sm="3" >User: </Form.Label>
                    <Col sm="9">
                      <Select
                        aria-label='User'
                        placeholder="Select User"
                        required
                        options={users.map(user => ({ ...user, label: `${user.first_name} ${user.last_name}` }))}
                        value={user}
                        onChange={(user) => setUser(user)}
                      />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mt-4" controlId="project">
                    <Form.Label column sm="3">Project: </Form.Label>
                    <Col sm="9">
                      <Select
                        aria-label='Project'
                        placeholder="Select Project"
                        required
                        options={projects.map(project => ({ ...project, label: project.value }))}
                        value={project}
                        onChange={(project) => setProject(project)}
                      />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mt-4" controlId="fromDate">
                    <Form.Label column sm="3">Date Range: </Form.Label>
                    <Col sm="4">
                      <Form.Control 
                        type="date" 
                        value={fromDate} 
                        onChange={(event) => { event.target.value ? setFromDate(event.target.value) : setFromDate(null); }}  
                        placeholder="From Date" 
                      />
                    </Col>
                    <Col sm="1" />
                    <Col sm="4">
                      <Form.Control 
                        type="date" 
                        value={toDate} 
                        onChange={(event) => { event.target.value ? setToDate(event.target.value) : setToDate(null); }} 
                        placeholder="To Date" 
                      />
                    </Col>
                </Form.Group>
                <Row className="justify-content-center">
                  <Col className="text-center">
                    <Button className="mt-5 w-75" variant="primary" size="lg" type="submit">
                        Create Expense Report
                    </Button>
                  </Col>
                </Row>
            </Form>
          </Container>
        </div>
    )
}